export const AptLoadingSpinnerComponent = {
  template: `<div ng-if="$ctrl.isLoading || ($ctrl.isLoading == null)" data-test-selector="loading-indicator">
    <i class="fa fa-spinner fa-spin"></i> Loading
  </div>`,
  bindings: {
    isLoading: '<'
  }
};
